import src from "IMAGE";
export default { src, width: 1732, height: 406, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALUlEQVR42gEiAN3/AF9dS0lBPkdEQT5APkA9R0QAWVc/PSEeIyAiHx8cIh8iH4x7BwxldBMSAAAAAElFTkSuQmCC"};
